import Link from '@eliadmin/core/src/components/link';

import { cn } from '@eliadmin/core/src/utils/style-utils';

export interface ContactTabProps {
  icon: React.ReactNode;
  href: string;
  value: string;
  label: string;
}

export function ContactTab({ icon, href, value, label }: ContactTabProps) {
  return (
    <Link
      prefetch={false}
      href={href}
      target="_blank"
      className={cn(
        'group',
        'relative flex w-full items-center justify-start gap-5 border-b border-b-black/10 pb-6',
      )}
    >
      {icon}
      <div className="flex w-full flex-col items-start justify-start gap-2">
        <p
          className={cn('text-sm text-primary/80', 'transition-all group-hover:text-secondary/80')}
        >
          {label}
        </p>
        <span
          className={cn(
            'text-base font-semibold text-primary lg:text-lg',
            'transition-all group-hover:text-secondary',
          )}
        >
          {value}
        </span>
      </div>
      <div
        className={cn(
          'absolute bottom-0 left-0 h-full max-h-0 w-full bg-secondary',
          'transition-all group-hover:max-h-[5px]',
        )}
      />
    </Link>
  );
}
